export default __webpack_public_path__ + "assets/fonts/1c6b0ebafe336967cafdcd3dbe5f89e4.woff";